import { TableHeaderCell } from 'common/components';
import type { TableFilterOption } from '../CallsTable';

type PartyStatusCellProps = {
    filterLeadStatus: string;
    partyStageOptions: TableFilterOption[];
    onFilterLeadStatus: (value: string) => void;
};

export const PartyStatusCell = ({ filterLeadStatus, partyStageOptions, onFilterLeadStatus }: PartyStatusCellProps) => {
    const options = [{ value: '', label: 'All statuses' }, ...partyStageOptions];
    const selectedValues = filterLeadStatus ? filterLeadStatus.split(',').filter(Boolean) : [];

    return (
        <TableHeaderCell
            label='Party status'
            isSearchable
            filterOptions={{
                mode: 'multi',
                options,
                selectedValues,
                onChange: (values) => onFilterLeadStatus(values.join(',')),
            }}
        />
    );
};
